import AOS from 'aos';

AOS.init({
    once: true,
    offset: 100,
    startEvent: 'load',
});
AOS.refresh(true);

$(window).on('scroll', function () {
  AOS.refresh();
});

// set transition delay to zero
$(document).on('mouseover', '.aos-animate.aos-init', function () {
  $(this).addClass('aos-animation-ready');
});

// fix for Safari back button cache issue with playing video
window.onpageshow = function (event) {
  if (event.persisted) {
      window.location.reload();
  }
};
